import React from 'react'
import { Button } from '@mui/material'
import DateOutlinedInput from '../../input/DateOutlinedInput'
import CustomOutlinedInput from '../../input/CustomOutlinedInput'
import SearchIcon from '@mui/icons-material/Search'
import LayersClearIcon from '@mui/icons-material/LayersClear'
import RestartAltIcon from '@mui/icons-material/RestartAlt'
import RotateLeftIcon from '@mui/icons-material/RotateLeft';

const BidSearchForm = ({ 
        targetDateId, 
        targetDateValue, 
        targetDateOnChange,
        keywordId, 
        keywordValue, 
        keywordOnChange, 
        handleSearch, 
        handleSearchClear, 
        display_search = true
    }) => {
    return (
        <div style={{display:'flex'}}>
            {/*
            <div>
                <DateOutlinedInput 
                    id       = { targetDateId } 
                    label    = "登録日" 
                    value    = { targetDateValue } 
                    onChange = { targetDateOnChange } 
                />
            </div>
            */}
            {
                display_search ?
                <>
                <div style={{marginLeft:'1px'}}>
                    <CustomOutlinedInput
                        type     = "text" 
                        id       = { keywordId } 
                        value    = { keywordValue } 
                        label    = "キーワードを入力して検索" 
                        width    = "250px" 
                        onChange = { keywordOnChange } 
                    />
                </div>
                </>
                :
                <></>
            }
            <div style={{marginLeft:'10px'}}>
                <Button
                    color     = "secondary"
                    style     = {{color:'#fff'}}
                    size      = "midium"
                    variant   = "contained"
                    onClick   = { handleSearch }
                    startIcon = {<SearchIcon />}
                    sx        = {{paddingLeft:'30px'}}
                >
                </Button>
            </div>
            <div style={{marginLeft:'10px'}}>
                <Button
                    color     = "secondary"
                    style     = {{color:'#fff'}}
                    size      = "midium"
                    variant   = "contained"
                    onClick   = { handleSearchClear }
                    startIcon = {<RotateLeftIcon />}
                    sx        = {{paddingLeft:'30px'}}
                >
                </Button>
            </div>
        </div>
    );
}

export default BidSearchForm